import React from "react";
import { WizardStep } from "../../machines/immersive-wizard.machine";
import { WebDemoProps } from "../../types/wizard.types";
import Browser from "./Browser";
import WebsiteHeader from "./WebsiteHeader";
import WebsiteContent from "./WebsiteContent";
import RankTrackingAppDemo from "./RankTrackingAppDemo";
import CommittedClubWebDemo from "./CommittedClubWebDemo";

const WebDemo: React.FC<WebDemoProps> = ({ formData, currentStep }) => {
  const renderContent = () => {
    if (currentStep === WizardStep.RankTrackingApp) {
      return (
        <RankTrackingAppDemo
          appointmentsEnabled={formData.appointmentsEnabled}
          classesEnabled={formData.classesEnabled}
          brandColor={formData.color}
          currentStep={currentStep}
          formData={formData}
        />
      );
    }

    if (currentStep === WizardStep.CommittedClubApp) {
      return <CommittedClubWebDemo formData={formData} />;
    }

    return (
      <>
        <WebsiteHeader
          logo={formData.logo}
          brandColor={formData.color}
          showSkeleton={!formData.logo && currentStep === WizardStep.Logo}
          businessName={formData.subdomain}
          businessUrl={formData.subdomain}
          currentStep={currentStep}
        />

        <WebsiteContent
          appointmentsEnabled={formData.appointmentsEnabled}
          classesEnabled={formData.classesEnabled}
          brandColor={formData.color}
          currentStep={currentStep}
          formData={formData}
        />
      </>
    );
  };

  return (
    <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-p-2">
      {/* Desktop Browser Container */}
      <div
        className="tw-bg-gray-100 tw-rounded-lg tw-overflow-hidden tw-shadow-2xl tw-border tw-border-gray-300"
        style={{
          width: "100%",
          maxWidth: "1200px",
          height: "85vh",
          minHeight: "700px",
        }}
      >
        <Browser
          url={
            formData.subdomain
              ? `${formData.subdomain}.pushpress.com`
              : "yoursite.pushpress.com"
          }
          currentStep={currentStep}
        />

        <div
          className="tw-bg-white tw-transition-all tw-duration-500 tw-overflow-y-auto tw-relative"
          style={
            {
              "--brand-color": formData.color,
              height: "calc(100% - 70px)", // Account for browser chrome height
            } as React.CSSProperties
          }
        >
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default WebDemo;
